import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const EMAIL_REGEX =
  /^([\w!#$%&'*+\-/=?^`{|}~]+\.)*[\w!#$%&'*+\-/=?^`{|}~]+@((((([a-zA-Z0-9]{1}[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]{1})|[a-zA-Z])\.)+[a-zA-Z]{2,20})|(\d{1,3}\.){3}\d{1,3}(:\d{1,5})?)$/;

function isNullOrEmptyValue(value: any): boolean {
  return (
    value == null ||
    value.length === 0 ||
    (typeof value === 'string' && value.trim().length === 0)
  );
}

/**
 * Handle both
 */
export class CustomValidator {
  static required(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return isNullOrEmptyValue(control.value) ? { required: true } : null;
    };
  }

  static email(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return isNullOrEmptyValue(control.value) ||
        EMAIL_REGEX.test(control.value)
        ? null
        : { email: true };
    };
  }
}
